import Modal from 'react-modal'

import './style.styl'

export const defaultContentStyle = {
  // This is how to get rid of default styles from the lib ATM
  position: '',
  top: '',
  left: '',
  right: '',
  bottom: '',
  overflow: '',
  background: '#fff',
  outline: 'none',
}

export const defaultOverlayStyle = {
  backgroundColor: 'rgba(28,35,39,0.8)',
  zIndex: 10001,
}

const Wrapper = ({ style, ...rest }) => (
  <Modal
    portalClassName="DefaultModalPortal"
    contentLabel="Modal"
    {...rest}
    style={{
      overlay: Object.assign({}, defaultOverlayStyle, (style && style.overlay) || {}),
      content: Object.assign(
        {},
        defaultContentStyle,
        { borderRadius: 4, border: '1px solid #ccc' },
        (style && style.content) || {}
      ),
    }}
  />
)

export default Wrapper



// WEBPACK FOOTER //
// ./src/scripts/components/shared/Modal/index.js